export const home = {
  'seo.title': 'Sofia and Elena — Nutritional Science and Cosmetology | Dual Expertise',
  'seo.description': 'Joint work of two expert nutritionists at the intersection of nutritional science and cosmetology. Hormonal balance restoration, GI tract work, metabolism and skin health. Individual approach and consilium of two specialists.',
  'seo.keywords': 'nutritionist, cosmetologist, health, hormones, GI tract, metabolism, child nutrition, Sofia, Elena, nutritionist consultation',

  'hero.title': 'A system where your body\nfinally sounds beautiful',
  'hero.subtitle': 'Joint work of two experts at the intersection of nutritional science and cosmetology.\nWe don\'t treat symptoms — we rebuild your health "brick by brick".',
  'hero.cta': 'Start Your Journey',
  'hero.imageAlt': 'Sofia and Elena — nutrition and cosmetology experts',
  'hero.ctaAria': 'Start your journey to health',

  'whyTwo.title': 'Why two experts = your result ×10',
  'whyTwo.description': 'While one expert restores your hormonal balance and GI tract function, the other builds your metabolism, works with deficiencies and ensures your skin glows.',
  'whyTwo.quote': 'You get double control and deep expertise from two sides simultaneously.',
  'whyTwo.imageAlt': 'Professional nutritionist consultation',
  'whyTwo.experts': 'Experts',
  'whyTwo.result': 'Result',

  'philosophy.title': 'Chaos in mind = chaos in body',
  'philosophy.belief': 'We don\'t believe in diets. We believe in knowledge.',
  'philosophy.description': 'We teach you to understand your body\'s signals, so that in 2 months you become your own best nutritionist.',

  'cta.title': 'Ready to stop trying\nand start getting results?',
  'cta.primary': 'Choose Program',
  'cta.secondary': 'Free Diagnostic',
  'cta.primaryAria': 'Choose a nutrition program',
  'cta.secondaryAria': 'Book a free diagnostic',
};